import { render } from "./record.vue?vue&type=template&id=446c4588&scoped=true&ts=true&lang=pug"
import script from "./record.vue?vue&type=script&lang=ts"
export * from "./record.vue?vue&type=script&lang=ts"

import "./record.vue?vue&type=style&index=0&id=446c4588&lang=stylus&scoped=true"

import exportComponent from "/builds/findsoft/hero/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-446c4588"]])

export default __exports__